import { Query, Store, StoreConfig } from "@datorama/akita";
import { Observable, map } from "rxjs";

type OpenedWishlistsState = {
    [wishlistId: number]: boolean;
};

const createInitialState = (): OpenedWishlistsState => {
    return {};
};

@StoreConfig({
    name: OpenedWishlistsUIStore.name,
})
export class OpenedWishlistsUIStore extends Store<OpenedWishlistsState> {
    private query: Query<OpenedWishlistsState>;

    public constructor() {
        super(createInitialState());
        this.query = new Query(this);
    }

    openWishlist(wishlistId: number) {
        this.update((state) => {
            return {
                ...state,
                [wishlistId]: true,
            };
        });
    }

    closeWishlist(wishlistId: number) {
        this.update((state) => {
            return {
                ...state,
                [wishlistId]: false,
            };
        });
    }

    toggleWishlist(wishlistId: number) {
        this.update((state) => {
            if (state[wishlistId]) {
                return {
                    ...state,
                    [wishlistId]: false,
                };
            } else {
                return {
                    ...state,
                    [wishlistId]: true,
                };
            }
        });
    }

    selectWishlistIsOpened(
        wishlistId: number,
        byDefault = false
    ): Observable<boolean> {
        this.update((state) => ({ ...state, [wishlistId]: byDefault }));
        return this.query.select().pipe(
            map((state) => {
                return state[wishlistId] ?? byDefault;
            })
        );
    }
}
